module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG0b3e1899bcc0a26372d88e668647a49c.0b3e1899.png";